<template>
  <div :key="key">
    <template v-if="pdf">
      <FinanceInvoiceShowPdf v-if="bill.data" :data="bill.data" ref="pdf" />
    </template>
    <template v-else>
      <FinanceInvoiceShowStatus
        v-if="bill.data"
        :status="status"
        :on-change-status="changeStatus"
        :system-data="bill.data['fin_system_data']"
        :fin-system="finSystem"
      />
      <FinanceInvoiceShow
        v-if="bill.data"
        :data="bill.data"
        ref="show"
        :show-tax="!status || status === 'new'"
      >
        <template slot="invoicing_company">
          <v-select
            v-if="!status || status === 'new'"
            v-model="bill.data.invoicing_company_id"
            :items="companyList"
            dense
            hide-details
            outlined
            class="f12"
            height="30"
            :menu-props="{ bottom: true, offsetY: true }"
            :item-text="
              (i) => (i.name ? bill.data.client.name + ' — ' + i.name : bill.data.client.name)
            "
            item-value="id"
            style="max-width: 400px"
            @input="onInput"
          />
        </template>
        <template v-if="finSystem === 'manual'">
          <template v-if="!status || status === 'new'">
            <v-text-field
              slot="number"
              v-model="bill.data['bill_number']"
              dense
              hide-details
              validate-on-blur
              outlined
              :rules="[(v) => v !== null || '']"
              placeholder="—"
              class="f12"
              height="30"
              @input="onInput"
            />
            <v-text-field
              slot="link"
              v-model="bill.data['bill_link']"
              dense
              hide-details
              validate-on-blur
              outlined
              :rules="[(v) => v !== null || '']"
              placeholder="—"
              class="f12"
              height="30"
              @input="onInput"
            />
          </template>
        </template>
        <template v-else>
          <div slot="number">
            {{ bill.data['bill_number'] || '—' }}
          </div>
          <div slot="link">
            {{ bill.data['bill_link'] || '—' }}
          </div>
        </template>
        <template v-if="!status || status === 'new'">
          <v-select
            slot="days"
            dense
            hide-details
            validate-on-blur
            outlined
            v-model="bill.data['bill_days_to_pay']"
            :items="listPaymentTerm"
            item-value="days"
            item-text="description"
            :placeholder="
              bill.data['bill_days_to_pay'] !== null ? String(bill.data['bill_days_to_pay']) : '—'
            "
            class="f12"
            height="30"
            :menu-props="{ bottom: true, offsetY: true }"
            :rules="[(v) => v !== null || '']"
            @change="onInput"
          >
            <template v-slot:append-outer>
              <div class="f12">
                {{ localStorage.translations.pages.finance['invoice-table']['day_term'] }}
              </div>
            </template>
          </v-select>
          <v-sheet slot="tax" max-width="150">
            <v-select
              dense
              hide-details
              validate-on-blur
              outlined
              class="f12 none_border"
              v-model="billTax.data['vat_code']"
              :items="listVatCode"
              item-value="code"
              item-text="percent"
              :placeholder="
                billTax.data['tax_percent'] !== null ? String(billTax.data['tax_percent']) : '—'
              "
              height="30"
              :menu-props="{ bottom: true, offsetY: true }"
              @change="changeTax"
              :rules="[(v) => v !== null || '']"
            >
              <template v-slot:append-outer>
                <div class="f12 none_border fw500">%</div>
              </template>
              <template v-slot:item="scope">
                {{ scope.item.percent + '% ' + scope.item.description }}
              </template>
            </v-select>
          </v-sheet>
        </template>
        <FinanceInvoiceShowTable
          :key="tableKey"
          :works="work_types"
          :extras="extra_works"
          :edit="!status || status === 'new'"
          :on-percent-change="changeWorkPercent"
          :tax="billTax.data['tax_percent']"
          :extra_tax_percent="billTax.data['extra_tax_percent']"
          :extra_vat_code="{value: billTax.data['extra_vat_code'] || billTax.data['vat_code']}"
        />
      </FinanceInvoiceShow>
      <LoadingAnimation v-else/>
      <v-card v-if="bill.data" width="100%" max-width="900" tile class="mb-5 mx-auto pa-4">
        <BaseInput
          type="textarea"
          :label="localStorage.translations.pages['finance']['period-table']['notes']"
          v-model="bill.data['invoice_free_text']"
          :rules="[v => v ? v.length < 500 || localStorage.translations.pages.common.rules['dolzhno-byt-menshe-500-simvolov'] : true]"
          :readonly="pdf || (status && status !== 'new')"
          @input="onInput"
        />
      </v-card>
      <template v-if="finSystem !== 'manual'">
        <v-card
          v-if="!status || status === 'new' || status === 'error'"
          class="mb-5 mx-auto d-flex justify-end"
          width="100%"
          max-width="900"
          tile
          flat
          color="transparent"
        >
          <BaseButton
            v-if="bill.data"
            :disabled="navigationGuardianActive || !activeChangeStatus"
            @click="dialog = true"
          >
            <template slot="icon">
              <IconsFinanceNetvisor v-if="finSystem === 'netvisor'" />
              <IconsFinanceProcountor v-else-if="finSystem === 'procountor'" />
              <IconsFinanceHeeros v-else />
            </template>
          </BaseButton>
        </v-card>
      </template>
    </template>
    <div class="fixedBtn">
      <BaseButton @click="onPdf" v-if="!pdf && status && status !== 'new'" round size="60" icon_only
                  default_icon="button-create_pdf"/>
      <BaseTooltip v-if="(!status || status === 'new')"
                   :tooltip="localStorage.translations.pages.common['buttons']['sohranit']">
        <BaseButton @click="onSave" :disabled="!navigationGuardianActive" round size="60" icon_only
                    default_icon="button-save"/>
      </BaseTooltip>
      <template v-if="pdf">
        <BaseButton @click="onShow" round size="60" icon_only default_icon="button-back"/>
        <BaseButton @click="onDownload" round size="60" icon_only default_icon="button-create_pdf"/>
      </template>
    </div>
    <v-dialog width="600" v-if="dialog" v-model="dialog">
      <v-card class="pa-10">
        <v-btn icon absolute right top class="mt-n2 mr-n2" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="d-flex flex-column justify-center align-center">
          <div class="f30">{{ localStorage.translations.pages.common['buttons']['send'] }} ?</div>
        </div>
        <div class="d-flex justify-space-around mt-4">
          <v-hover v-slot="{ hover }">
            <v-btn fab :outlined="!hover" :dark="hover" color="red" @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot="{ hover }">
            <v-btn
              fab
              depressed
              :outlined="!hover"
              :dark="hover"
              color="#277FAF"
              @click="onSend()"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-hover>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingAnimation from 'components/LoadingAnimation'
import FinanceInvoiceShow from 'components/finance/invoice/FinanceInvoiceShow'
import FinanceInvoiceShowTable from 'components/finance/invoice/FinanceInvoiceShowTable'
import FinanceInvoiceShowPdf from 'components/finance/invoice/FinanceInvoiceShowPdf'
import FinanceInvoiceShowStatus from 'components/finance/invoice/FinanceInvoiceShowStatus'
import BaseInput from 'components/base/BaseInput'
import IconsFinanceHeeros from 'components/icons/finance/IconsFinanceHeeros.vue'
import IconsFinanceNetvisor from 'components/icons/finance/IconsFinanceNetvisor.vue'
import IconsFinanceProcountor from 'components/icons/finance/IconsFinanceProcountor.vue'

export default {
  name: "invoiceShow",
  components: {
    IconsFinanceProcountor,
    IconsFinanceNetvisor,
    IconsFinanceHeeros,
    BaseInput,
    FinanceInvoiceShowStatus,
    FinanceInvoiceShowPdf,
    FinanceInvoiceShowTable,
    FinanceInvoiceShow,
    LoadingAnimation,
  },
  computed: {
    ...mapGetters('workClientProjectsClientBills', {
      bill: 'workClientProjectsClientBillsShow',
      statusList: 'workClientProjectsClientBillStatuses',
      billTax: 'workClientProjectsClientBillsShowTax',
    }),
    ...mapGetters('workClient', ['workClientShow']),
    ...mapGetters('commonVatCode', {listVatCode: 'getCommonVatCodeGrid'}),
    ...mapGetters('commonPaymentTerms', {listPaymentTerm: 'getCommonPaymentTermGrid'}),
    ...mapGetters(['companiesConfig']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    ...mapGetters('workClientInvoicingCompany', ['workClientInvoicingCompanyAll']),
    t() {
      return this.localStorage.translations.pages.finance['invoice-table']
    },
    p() {
      return this.localStorage.translations.pages.finance['period-table']
    },
    sp() {
      return this.localStorage.translations.pages['setting-setting_company'].all
    },
    tr() {
      return {
        ytunnus: this.t['y-tunnus'],
        name: this.t['client'],
        vat: this.t['alv'],
        billing_street: this.t['billing_address'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['ulitsa'].toLowerCase() + ')',
        billing_city: this.t['billing_address'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['gorod'].toLowerCase() + ')',
        billing_zip: this.t['billing_address'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['indeks'].toLowerCase() + ')',
        street: this.t['billing_address'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['ulitsa'].toLowerCase() + ')',
        city: this.t['billing_address'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['gorod'].toLowerCase() + ')',
        zip: this.t['billing_address'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['indeks'].toLowerCase() + ')',
        company_name: this.sp['company_name'],
        company_id: this.sp['company_id'],
        billing_address_street: this.sp['company_address_billing'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['ulitsa'].toLowerCase() + ')',
        billing_address_city: this.sp['company_address_billing'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['gorod'].toLowerCase() + ')',
        billing_address_zip: this.sp['company_address_billing'] + ' (' +
          this.localStorage.translations.pages['sales_project']['project_client-labels']['indeks'].toLowerCase() + ')',
        iban: 'IBAN',
        bic: 'BIC',
        extra_work_group_code: this.sp['group-extra-work-code'],
        extra_work_group_name: this.sp['group-extra-work-name'],
        bill_days_to_pay: this.t['pay_terms'],
        client_project_number: this.localStorage.translations.pages['sales_project']['project_client-labels']['nomer-obekta-klienta'],
        first_name: this.localStorage.translations.pages['sales_project']['project_client-labels']['kontaktnoe-litso'] +
          ' (' + this.localStorage.translations.pages['setting-client']['persons']['imya'].toLowerCase() + ')',
        last_name: this.localStorage.translations.pages['sales_project']['project_client-labels']['kontaktnoe-litso'] +
          ' (' + this.localStorage.translations.pages['setting-client']['persons']['familiya'].toLowerCase() + ')',
      }
    },
    errRoute() {
      return {
        client: {name: 'clientsCompanyShow', params: {id: this.bill.data.client.id}},
        account_settings: {name: 'SettingCompanyGeneral'},
        contact_client_person: {
          name: 'ProjectsProjectShow', params: {id: this.bill.data.project.id}
        },
        project: {
          name: 'ProjectsProjectShow', params: {id: this.bill.data.project.id}
        },
        invoicing_company: {
          name: 'clientsCompanySalesShow',
          params: {id: this.bill.data.invoicing_company ? this.bill.data.invoicing_company.id : ''}
        }
      }
    },
    finSystem() {
      return this.status && this.status !== 'new'
        ? (this.bill.data['fin_system']
          ? this.bill.data['fin_system']
          : 'manual')
        : this.companiesConfig['fin_system']
          ? this.companiesConfig['fin_system']
          : 'manual'
    },
    activeChangeStatus() {
      return this.bill.data
        ? this.bill.data['bill_days_to_pay'] !== null && this.billTax.data['vat_code'] !== null
        : false
    },
    edit() {
      return this.$route.name.includes('ShowEdit')
    },
    pdf() {
      return this.$route.name.includes('ShowPdf')
    },
    status() {
      return this.bill.data ? this.bill.data['bill_status'] : null
    },
    statusList() {
      let result = []
      this.workClientProjectsClientBillStatuses.forEach(element => {
          result.push({
            name: this.localStorage.translations.pages.finance['invoice-status'][element.translation],
            color: element.color,
            status: element.status,
          })
        }
      )
      return result
    },
    work_types() {
      return this.billTax.data
        ? this.billTax.data['work_types'].filter(i => i.id !== null && i.name !== null)
        : []
    },
    extra_works() {
      return this.billTax.data
        ? this.billTax.data['extra_works'].filter(i => i.id !== null && i.name !== null)
        : []
    },
    companyList() {
      let result = []
      if (this.bill.data && this.bill.data.client) {
        result.push({
          id: null,
          name: ''
        })
        result = result.concat(this.workClientInvoicingCompanyAll)
      }
      return result
    }
  },
  data: () => ({
    key: 0,
    tableKey: 0,
    dialog: false,
  }),
  created() {
    this.onCommonVatCodeGrid({limit: 0, page: 1, sort: {param: 'percent', value: 'acs'}})
    this.onCommonPaymentTermGrid({limit: 0, page: 1, sort: {param: 'days', value: 'acs'}})
    this.onWorkClientInvoicingCompanyAll()
    this.getPageData()
  },
  methods: {
    ...mapActions('workClientProjectsClientBills', [
      'onWorkClientProjectsClientBillShow',
      'onWorkClientProjectsClientBillUpdate',
      'onWorkClientProjectsClientBillUpdateStatus',
      'onWorkClientProjectsClientBillUpdateTaxes',
      'onWorkClientProjectsClientBillSend',
    ]),
    ...mapActions('workClient', ['onWorkClientShow']),
    ...mapActions(['onLoadingAnimationFullPage']),
    ...mapActions('commonVatCode', ['onCommonVatCodeGrid']),
    ...mapActions('commonPaymentTerms', ['onCommonPaymentTermGrid']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions('workClientInvoicingCompany', ['onWorkClientInvoicingCompanyAll']),

    async getPageData() {
      await this.onWorkClientProjectsClientBillShow({id: this.$route.params.invoice_id}).then(() => {
        this.fixInvoiceCompany()
        this.fixPercent()
        this.onCheckChange({overwrite: true})
      })
    },

    fixInvoiceCompany() {
      this.bill.data.invoicing_company_id =
        this.bill.data.invoicing_company ? this.bill.data.invoicing_company.id : null
    },

    onCheckChange({overwrite}) {
      this.onNavigationGuardianCheck({
        data: {
          bill_number: this.bill.data['bill_number'] || '',
          bill_link: this.bill.data['bill_link'] || '',
          bill_days_to_pay: this.bill.data['bill_days_to_pay'],
          invoice_free_text: this.bill.data['invoice_free_text'] || '',
          invoicing_company_id: this.bill.data['invoicing_company_id'] || -1
        },
        overwrite,
      })
    },

    onInput() {
      this.onCheckChange({overwrite: false})
    },

    fixPercent() {
      if (this.billTax.data['extra_tax_percent'] === null)
        this.billTax.data['extra_tax_percent'] =
          this.billTax.data['tax_percent']
      this.tableKey++
    },

    onSave() {
      if (this.$refs.show) {
        if (this.$refs.show.$refs.form.validate()) {
          let data = {
            id: this.$route.params.invoice_id,
            data: {
              bill_days_to_pay: this.bill.data['bill_days_to_pay'],
              invoice_free_text: this.bill.data['invoice_free_text'],
            }
          }
          data.data.invoicing_company_id = this.bill.data.invoicing_company_id
          if (this.finSystem === 'manual') {
            data.data.bill_number = this.bill.data['bill_number']
            data.data.bill_link = this.bill.data['bill_link']
          }
          this.saveChanges(data)
        }
      }
    },

    onPdf() {
      this.$router.push({name: this.$route.name + 'Pdf'})
    },

    onShow() {
      this.$router.push({name: this.$route.name.replace('Pdf', '')})
    },

    async saveChanges(data, hide_message) {
      await this.onWorkClientProjectsClientBillUpdate(data)
        .then(() => {
          this.fixInvoiceCompany()
          this.onCheckChange({overwrite: true})
          if (!hide_message)
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['izmeneniya-uspeshno-sohraneny'],
                IsError: false,
              },
              {root: true},
            )
          this.fixPercent()
        })
        .catch((err) => {
          console.log('err', err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            {root: true},
          )
        })
    },

    async saveTaxes(data) {
      await this.onWorkClientProjectsClientBillUpdateTaxes({id: this.$route.params.invoice_id, data: data})
        .then(() => {
          this.fixPercent()
        })
    },

    async changeStatus(status) {
      if (this.$refs.show && this.$refs.show.$refs.form.validate()) {
        if (this.bill.data['bill_status'] === 'new') {
          let data = {
            id: this.$route.params.invoice_id, data: {
              bill_number: this.bill.data['bill_number'],
              bill_link: this.bill.data['bill_link'],
              bill_days_to_pay: this.bill.data['bill_days_to_pay'],
            }
          }
          await this.saveChanges(data, true)
            .then(() => {
              this.onChangeStatus(status)
            })
        } else {
          await this.onChangeStatus(status)
        }

      }
    },

    async onChangeStatus(status) {
      await this.onWorkClientProjectsClientBillUpdateStatus({
        id: this.$route.params.invoice_id,
        status: status,
      })
        .then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['izmeneniya-uspeshno-sohraneny'],
              IsError: false,
            },
            {root: true},
          )
          this.bill.data['bill_status'] = status
        })
        .catch((err) => {
          console.log('err', err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            {root: true},
          )
        })
    },

    changeTax() {
      let data = {
        vat_code_id: this.listVatCode.filter(
          i => i.code == this.billTax.data['vat_code'])[0].id
      }
      this.saveTaxes(data)
    },

    changeWorkPercent(vat_id, work_id) {
      let data = {}
      if (work_id) {
        data.custom_work_types = [{work_type_id: work_id, vat_code_id: vat_id}]
        data.vat_code_id = this.listVatCode.filter(
          i => i.code == this.billTax.data['vat_code'])[0].id
        data.extra_types_vat_code_id = this.listVatCode.filter(
          i => i.code == this.billTax.data['extra_vat_code'] ||
            i.code == this.billTax.data['vat_code'])[0].id
      } else {
        data.extra_types_vat_code_id = vat_id
        data.vat_code_id = this.listVatCode.filter(
          i => i.code == this.billTax.data['vat_code'])[0].id
      }
      this.saveTaxes(data)
    },

    onDownload() {
      if (this.$refs.pdf) {
        this.$refs.pdf.$refs.invoice.onDownload()
      }
    },

    async onSend() {
      if (this.$refs.show && this.$refs.show.$refs.form.validate()) {
        this.onLoadingAnimationFullPage({value: true})
        await this.onWorkClientProjectsClientBillSend({id: this.$route.params.invoice_id})
          .then(() => {
            this.getPageData()
            this.onLoadingAnimationFullPage({value: false})
          })
          .catch(err => {
            let status = err.response ? err.response.status : null
            let modalData = []
            let netvisorError = err.response.data.message.includes('Netvisor request error')
            let procountorError = err.response.data.message.includes('procountor')
            if (netvisorError) {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['oshibka'] +
                    (status ? ' ' + status : ''),
                  modalData: {
                    title: err.response.data.message,
                    data: [{}],
                  },
                  IsError: true,
                },
                { root: true },
              )
            } else if (procountorError) {
              let messageIndex = err.response.data.message.search('{"errors":')
              let messages = err.response.data.message
              let messageErrors = JSON.parse(messages.slice(messageIndex))
              let message = []
              for (let i in messageErrors) {
                let mesError = messageErrors[i]
                for (let j in mesError) {
                  message = mesError[j].message
                }
              }
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['oshibka'] +
                    (status ? ' ' + status : ''),
                  modalData: {
                    title: message,
                    data: [{}],
                  },
                  IsError: true,
                },
                { root: true },
              )
            } else {
              let message =
                err.response && err.response.data && err.response.data.message
                  ? JSON.parse(err.response.data.message)
                  : []
              if (message['missing_data']) message = message['missing_data']
              for (let i in message)
                modalData.push({
                  route: this.errRoute[i],
                  text: message[i].map((data) => this.tr[data]).join('<br/>'),
                })
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['oshibka'] +
                    (status ? ' ' + status : ''),
                  modalData: {
                    title:
                      this.localStorage.translations.pages.common.notifications[
                        'fill_in_required_fields'
                      ],
                    data: modalData,
                  },
                  IsError: true,
                },
                { root: true },
              )
            }
          })
      }
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">
:deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
  min-height: 30px !important;
}

:deep() .v-list-item:hover {
  color: white !important;
}

:deep() input::placeholder {
  color: inherit !important;
}
</style>